import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import displayINRCurrency from "../helpers/displayCurrency";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await fetch(
        "https://lappyshop.onrender.com/api/my-orders",
        { credentials: "include" }
      );
      const data = await res.json();

      if (data.success) {
        setOrders(data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ CANCEL ORDER
  const cancelOrder = async (orderId) => {
    const confirmCancel = window.confirm("Cancel this order?");
    if (!confirmCancel) return;

    try {
      const res = await fetch(
        "https://lappyshop.onrender.com/api/cancel-order",
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orderId }),
        }
      );

      const data = await res.json();

      if (data.success) {
        alert("Order cancelled");
        fetchOrders();
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ STATUS COLORS
  const statusColor = (status) => {
    switch (status) {
      case "processing":
        return "bg-yellow-100 text-yellow-700";
      case "shipped":
        return "bg-blue-100 text-blue-700";
      case "delivered":
        return "bg-green-100 text-green-700";
      case "cancelled":
        return "bg-red-100 text-red-600";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <div className="p-2 md:p-4">

      {/* HEADER */}
      <h1 className="text-lg md:text-2xl font-semibold mb-4">
        My Orders
      </h1>

      {/* LOADING */}
      {loading && (
        <div className="text-center py-10 text-gray-500">
          Loading orders...
        </div>
      )}

      {/* EMPTY */}
      {!loading && orders.length === 0 && (
        <div className="bg-white p-6 rounded-xl text-center shadow">
          No orders found
        </div>
      )}

      {/* ORDERS LIST */}
      <div className="space-y-4">

        {orders.map((order) => (
          <div
            key={order._id}
            className="bg-white rounded-xl shadow p-4"
          >

            {/* TOP */}
            <div className="flex flex-col md:flex-row md:justify-between gap-2">

              <div>
                <p className="text-xs text-gray-500">
                  View
                </p>

                <Link
                  to={`/order/${order._id}`}
                  className="text-blue-600 text-md font-medium hover:underline active hover:text-red-500 font-bold"
                >
                  View Details
                </Link>
              </div>

              <span
                className={`px-3 py-1 text-xs rounded-full w-fit ${statusColor(
                  order.orderStatus
                )}`}
              >
                {order.orderStatus}
              </span>

            </div>

            {/* ITEMS */}
            <div className="mt-3 space-y-3">

              {order.items.map((item) => (
                <div
                  key={item._id}
                  className="flex gap-3 border-t pt-3"
                >

                  {/* IMAGE */}
                  <img
                    src={item.productId.productImage[0]}
                    alt={item.productId.productName}
                    loading="lazy"
                    className="w-16 h-16 object-contain bg-gray-100 rounded"
                  />

                  {/* INFO */}
                  <div className="flex-1">
                    <p className="text-sm font-medium line-clamp-2">
                      {item.productId.productName}
                    </p>

                    <p className="text-xs text-gray-500">
                      Qty: {item.quantity}
                    </p>
                  </div>

                  {/* PRICE */}
                  <p className="text-sm font-semibold text-gray-800">
                    {displayINRCurrency(
                      item.price * item.quantity
                    )}
                  </p>

                </div>
              ))}

            </div>

            {/* TOTAL */}
            <div className="flex justify-between items-center mt-4 border-t pt-3">

              <span className="font-semibold text-sm">
                Total
              </span>

              <span className="font-bold text-base">
                {displayINRCurrency(order.totalAmount)}
              </span>

            </div>

            {/* ACTIONS */}
            {order.orderStatus === "processing" && (
              <div className="mt-3 text-right">

                <button
                  onClick={() => cancelOrder(order._id)}
                  className="bg-red-600 text-white text-xs px-4 py-2 rounded-lg hover:bg-red-700 transition"
                >
                  Cancel Order
                </button>

              </div>
            )}

          </div>
        ))}

      </div>

    </div>
  );
};

export default MyOrders;